export function findFileMapKeyByBasename(
  fileMap: Record<string, File>,
  baseName: string
): string | null {
  const base = String(baseName || "").toLowerCase();
  if (!base) return null;
  const keys = Object.keys(fileMap || {});
  return (
    keys.find((k) => String(k).toLowerCase() === base) ||
    keys.find((k) => String(k).toLowerCase().endsWith(`/${base}`)) ||
    keys.find((k) => String(k).toLowerCase().endsWith(`\\${base}`)) ||
    null
  );
}

export async function readJsonFromFileMap(
  fileMap: Record<string, File>,
  key: string | null
): Promise<unknown | null> {
  if (!key) return null;
  const f = fileMap[key] || null;
  if (!f || typeof f.text !== "function") return null;
  try {
    const txt = await f.text();
    return JSON.parse(txt);
  } catch {
    return null;
  }
}

export async function readTextFromFileMap(
  fileMap: Record<string, File>,
  key: string | null
): Promise<string | null> {
  if (!key) return null;
  const f = fileMap[key] || null;
  if (!f || typeof f.text !== "function") return null;
  try {
    const txt = await f.text();
    return typeof txt === "string" ? txt : null;
  } catch {
    return null;
  }
}
